import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { rootReducerType } from "redux/combineReducers";
import Container from "common/components/Container/Container";
import {
	dashboardApi,
	useGetActiveStatsQuery,
	useGetConnectorSummaryQuery,
	useGetInactiveStatsQuery,
	useGetSummaryStatsQuery,
	useGetMenuQuery,
	useGetConnectorSummaryForStationV2Query,
	useGetSummaryStatsForStationQuery,
	useGetConnectorSummaryForAllStationV2Query,
} from "services/dashboardService";
import { decodeJWT } from "common/functions";
import i18n from "internationalization/i18n";
import { formatData } from "common/components/ConnectorsPieChart/utils/functions";
import ContainerCharts from "common/components/ContainerCharts/ContainerCharts";
import CustomiseDashboard from "common/components/CustomiseDashboard/CustomiseDashboard";
import { emailToUsername } from "common/utils";
import SlibarItem from "components/SlibarItem/SlibarItem"

type Props = {
	shouldRefresh?: boolean;
};
const Dashboard: React.FC<Props> = ({ shouldRefresh }): React.ReactElement => {
	const skip = [false, true];
	const [expanded, setExpanded] = useState(false);

	const { isLoggedIn } = useSelector(
		(state: rootReducerType) => state.authenticationReducer
	);

	const {stationId} = useSelector(
		(state: rootReducerType) => state.stationIdReducer
	);

	const [params, setParams] = useState({
		userName: emailToUsername(decodeJWT(isLoggedIn).email),
	});

	const dispatch = useDispatch(); 

	const { data: summaryStats } = useGetSummaryStatsQuery(params);
	const { data: menuData } = useGetMenuQuery(params, { skip: skip[0] });
	
	const { data: summ } = useGetConnectorSummaryQuery(params, { skip: skip[0] });
	const { data: activeStats, refetch: refetchActive } = useGetActiveStatsQuery(params);
	const { data: inactiveStats, refetch: refetchInactive } = useGetInactiveStatsQuery(params);
	const { data: summaryForStationV2} = useGetConnectorSummaryForStationV2Query({
		stationId: stationId,
	},{ skip: !stationId ? true : false });

	const { data: summaryForStation} = useGetSummaryStatsForStationQuery({
		stationId: stationId,
	},{ skip: !stationId ? true : false });

	const { data: SummaryForAll} = useGetConnectorSummaryForAllStationV2Query({
		stationId: stationId,
	});

	const [active, setActive] = useState(activeStats);
	const [inactive, setInactive] = useState(inactiveStats);

	useEffect(() => {
		refetchActive()
		refetchInactive()
		setActive(activeStats)
		setInactive(inactiveStats)
	}, [expanded])

	useEffect(() => {
		setParams({ userName: params.userName });
	}, [isLoggedIn]);

	useEffect(() => {
		if(stationId) {
			dispatch(
				dashboardApi.endpoints.getSummaryStatsForStation.initiate(
					{
						stationId: stationId,
					},
					{ subscribe: false, forceRefetch: true }
				)
			);
			dispatch(
				dashboardApi.endpoints.getConnectorSummaryForStationV2.initiate(
					{
						stationId: stationId,
					},
					{ subscribe: false, forceRefetch: true }
				)
			);
		}
	}, [stationId, dispatch, shouldRefresh]);

	useEffect(() => {
		dispatch(
			dashboardApi.endpoints.getMenu.initiate(
				{
					userName: "111",
				},
				{ subscribe: false, forceRefetch: true }
			)
		);
		dispatch(
			dashboardApi.endpoints.getConnectorSummaryForAllStationV2.initiate(
				{
					userName: params.userName,
				},
				{ subscribe: false, forceRefetch: true }
			)
		);
		dispatch(
			dashboardApi.endpoints.getConnectorSummary.initiate(
				{
					userName: params.userName,
				},
				{ subscribe: false, forceRefetch: true }
			)
		);
		dispatch(
			dashboardApi.endpoints.getActiveStats.initiate(
				{
					userName: params.userName,
				},
				{ subscribe: false, forceRefetch: true }
			)
		);
		dispatch(
			dashboardApi.endpoints.getInactiveStats.initiate(
				{
					userName: params.userName,
				},
				{ subscribe: false, forceRefetch: true }
			)
		);
		dispatch(
			dashboardApi.endpoints.getSummaryStats.initiate(
				{
					userName: params.userName,
				},
				{ subscribe: false, forceRefetch: true }
			)
		);
	}, [shouldRefresh, dispatch]);

	useEffect(() => setActive(activeStats), [activeStats]);
	useEffect(() => setInactive(inactiveStats), [inactiveStats]);

	const summary = formatData(summ);

	return (
		<div style={{ display: 'flex', flex: '1' }}>
			<SlibarItem 
				menuData={menuData}
			/>
			<Container
				backButton={false} 
				loadingPageName="Dashboard"
				subTitle={i18n.t("dashboard.subtitle")}
				renderCondition={summaryStats ? true : false}
				childrenExpanded={<CustomiseDashboard activeStats={active} inactiveStats={inactive} setInactiveStats={setInactive} setActiveStats={setActive} expanded={expanded} setExpanded={setExpanded} />}
				setExpanded={setExpanded}
				expanded={expanded}
			>
				<ContainerCharts
					summary={summary}
					summaryStats={summaryStats}
					SummaryForAll={SummaryForAll}
					summaryForStationV2={summaryForStationV2}
					summaryForStation={summaryForStation}
					shouldRefresh={shouldRefresh}
					activeStats={active}
					inactiveStats={inactive}
					setInactiveStats={setInactive}
					setActiveStats={setActive}
					expanded={expanded}
					setExpanded={setExpanded}
				/>
			</Container>
		</div>

	);
};

export default Dashboard;
